import Distance from "./Distance";
import "./style/DistanceItem.scss"
import "./style/Distance.scss";
import "./style/Index.scss"
import {createVNode, render} from "vue";

/**
 * 单利模式模式创建一个流程图
 */
class DistanceInstance {
    #dom = null
    #app = null
    #showPlan = false
    #dataList = []
    #config = null
    updateCallback = null

    constructor(dom, config) {
        this.dom = dom

        config.list.forEach(v => {
            if (Object.prototype.toString.call(v) === "[object Array]") {
                this.dataList.push(...v)
            } else if (Object.prototype.toString.call(v) === "[object Object]") {
                this.dataList.push(v)
            }
        })
        config.list = this.dataList

        this.app = createVNode(Distance, {
            tableData: config,
            update: (f) => this.updateCallback = f
        });
        this.config = config;
    }

    show() {
        if (!this.showPlan) {
            this.showPlan = true
            render(this.app, document.getElementById(this.dom));
        }
    }

    close() {
        if (this.showPlan) {
            this.dom.children.forEach(v => {
                v.remove()
            })
        }
    }

    update(id, config, status = null) {
        if (Object.prototype.toString.call(config) === "[object String]") {
            this.dataList.forEach(v => {
                if (v.id === id) {
                    v.status = config
                }
            })
        } else if (Object.prototype.toString.call(config) === "[object Object]") {
            this.dataList.forEach(v => {
                if (v.id === id) {
                    v.content = {...v.content, ...config}
                }
            })
        } else if (Object.prototype.toString.call(config) === "[object Array]") {
            this.dataList.forEach(v => {
                if (v.id === id) {
                    v.content.content = null
                    v.content.content = JSON.parse(JSON.stringify(config))
                }
            })
        }
        if (status) {
            this.dataList.forEach(v => {
                if (v.id === id) {
                    v.status = status
                }
            })
        }
        this.config.list = this.dataList
    }

    review() {
        if (this.updateCallback) {
            this.updateCallback(this.config)
        }
    }


    get config() {
        return this.#config;
    }


    set config(value) {
        this.#config = value;
    }

    get dom() {
        return this.#dom;
    }

    set dom(value) {
        this.#dom = value;
    }

    get showPlan() {
        return this.#showPlan;
    }


    get dataList() {
        return this.#dataList;
    }

    set showPlan(value) {
        this.#showPlan = value;
    }


    set dataList(value) {
        this.#dataList = value;
    }

    get app() {
        return this.#app;
    }

    set app(value) {
        this.#app = value;
    }
}

class DistanceController {

    #instance = null


    constructor() {
        if (new.target) {
            throw new Error("类 DistanceController 不允许实例化")
        }
    }

    /**
     * 构造
     * @param dom
     * @param config
     * @returns {*}
     * @constructor
     */
    static GetInstance(dom, config) {
        if (!this.instance) {
            this.instance = new DistanceInstance(dom, config);
        }

        return this.instance

    }

    set instance(value) {
        this.#instance = value;
    }


    get instance() {
        return this.#instance;
    }

}

export default DistanceController
